import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DraftsComponent } from "@shared/src/lib/components/drafts/drafts.component";
import { InboxComponent } from "@shared/src/lib/components/inbox/inbox.component";
import { LoginComponent } from "./pages/login/login.component";
import { MessageDetailComponent } from "@shared/src/lib/components/message-detail/message-detail.component";
import { SentComponent } from "@shared/src/lib/components/sent/sent.component";
import { UserSettingsComponent } from "./pages/user-settings/user-settings.component";
import { MessageDraftComponent } from "@shared/src/lib/components/new-message-draft/message-draft.component";
import { SignUpComponent } from "./pages/sign-up/sign-up.component";
import { ContactsComponent } from "@shared/src/lib/components/contacts/contacts.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "@shared/src/lib/components/terms-and-conditions/terms-and-conditions.component";
import { SecureDocumentsComponent } from "./pages/secure-documents/secure-documents.component";
import { SecureDocumentsUploadComponent } from "./pages/secure-documents-upload/secure-documents-upload.component";
import { AuthGuard } from "./auth/auth-guard";
import { SubscriptionComponent } from "./pages/subscription/subscription.component";

const routes: Routes = [
	{path: "login", component: LoginComponent},
	{path: "sign-up", component: SignUpComponent},
	{path: "subscription", component: SubscriptionComponent},
	{path: "inbox", component: InboxComponent, canActivate: [AuthGuard]},
	{path: "drafts", component: DraftsComponent, canActivate: [AuthGuard]},
	{path: "sent", component: SentComponent, canActivate: [AuthGuard]},
	{path: "contacts", component: ContactsComponent, canActivate: [AuthGuard]},
	{path: "secure-documents", component: SecureDocumentsComponent, canActivate: [AuthGuard]},
	{path: "settings", component: UserSettingsComponent, canActivate: [AuthGuard]},
	{path: "drafts/messages/:id", component: MessageDraftComponent, data: {canAddPhotos: true}, canActivate: [AuthGuard]},
	{path: "sent/messages/:id", component: MessageDetailComponent, canActivate: [AuthGuard]},
	{path: "inbox/messages/:id", component: MessageDetailComponent, canActivate: [AuthGuard]},
	{path: "secure-documents-upload", component: SecureDocumentsUploadComponent, canActivate: [AuthGuard]},
	{path: "privacy", component: PrivacyPolicyComponent, canActivate: [AuthGuard]},
	{path: "terms", component: TermsAndConditionsComponent, canActivate: [AuthGuard]},
	{
		path: "",
		redirectTo: "/inbox",
		pathMatch: "full"
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule
{ }
